import React from 'react';
import { SOCIAL_PROOF } from '../../data/mock';
import { Button } from '../ui/button';
import { Youtube, Play, ExternalLink } from 'lucide-react';

export const SocialProof = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-10 md:p-16 relative overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl" />
          
          <div className="relative grid md:grid-cols-2 gap-10 items-center">
            {/* Content */}
            <div>
              <div className="inline-flex items-center gap-2 bg-red-500/20 rounded-full px-4 py-2 mb-6">
                <Youtube className="w-5 h-5 text-red-400" />
                <span className="text-red-400 font-medium">YouTube Channel</span>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {SOCIAL_PROOF.title}
              </h2>
              
              <p className="text-slate-300 text-lg mb-6 leading-relaxed">
                {SOCIAL_PROOF.description}
              </p>
              
              <Button
                asChild
                size="lg"
                className="bg-red-500 hover:bg-red-600 text-white font-semibold shadow-lg shadow-red-500/30"
              >
                <a href={SOCIAL_PROOF.youtubeUrl} target="_blank" rel="noopener noreferrer">
                  <Play className="w-5 h-5 mr-2 fill-current" />
                  Visit {SOCIAL_PROOF.youtubeHandle}
                  <ExternalLink className="w-4 h-4 ml-2" />
                </a>
              </Button>
            </div>

            {/* Visual */}
            <div className="flex items-center justify-center">
              <div className="relative">
                <div className="w-48 h-48 md:w-64 md:h-64 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center shadow-2xl shadow-red-500/40">
                  <Youtube className="w-24 h-24 md:w-32 md:h-32 text-white" />
                </div>
                {/* Decorative rings */}
                <div className="absolute inset-0 w-48 h-48 md:w-64 md:h-64 rounded-full border-2 border-red-500/20 animate-ping" />
                <div className="absolute -inset-4 w-56 h-56 md:w-72 md:h-72 rounded-full border border-red-500/10" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
